import React from "react";
import { Outlet } from "react-router-dom";
import RequireAuth from "@/routes/RequireAuth";

// Layout for Login/Forgot Password screens
export const AuthLayout: React.FC = () => <Outlet />;

// Layout that enforces authentication for the Dashboard
export const DashboardAuthLayout: React.FC = () => (
  <RequireAuth>
    <Outlet />
  </RequireAuth>
);